module.exports = __webpack_public_path__ + "img/icon-form.79966f7d.svg";